import { query } from '@angular/animations';
import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Apollo } from 'apollo-angular';
import { Observable, of } from 'rxjs';

import * as CatalogActions from '@core/state/catalog/catalog.actions';

@Injectable({
  providedIn: 'root'
})
export class ProductAllResolver  {

  constructor(
    private store: Store,
    private router: ActivatedRoute
  ) { }

  mongoParam: any[];

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
      const queryParams = route.queryParamMap;
      const queryParamArray = [];


        queryParams.keys.forEach(key => {
          const values = queryParams.getAll(key);
          values.forEach(value => {
            const paramObject = {};
            paramObject[key] = value;
            queryParamArray.push(paramObject);
          });
        });

      this.mongoParam = queryParamArray

      this.store.dispatch(CatalogActions.updateCatalogQuery(
        {
          queryUpdate: this.mongoParam,
          currentPage: 1,
          sort: 'A-Z'
        }
      ));

      this.store.dispatch(CatalogActions.getCatalogProducts(
        {
          searchParam: this.mongoParam,
          currentPage: 1,
          sort: 'A-Z'
        }
      ));
    // })
    return of(true);
  }
}
